const THSR_PROJECT_ID = '633d2757a4fbd61d20ee34ae';

const THSR_MANUAL_PROJECT_ID = '6ac34c964be9504107a50a9f';
const THSR_NTU_STORM_PROJECT_ID = '69cb8779f1adff40d64010a5';
const THSR_III_STORM_PROJECT_ID = '699faf7cc3db24c20b354515';

const isThsrProject = (projectId) => projectId === THSR_PROJECT_ID;

const getManualProjectId = (selectedProjectId) =>
  isThsrProject(selectedProjectId) ? THSR_MANUAL_PROJECT_ID : selectedProjectId;

export {
  THSR_PROJECT_ID,
  THSR_MANUAL_PROJECT_ID,
  THSR_NTU_STORM_PROJECT_ID,
  THSR_III_STORM_PROJECT_ID,
  isThsrProject,
  getManualProjectId,
};
